import React, { useEffect, useState, useContext } from "react";
import { StaticPageContainer } from "./StaticPageStyled";

import { FormattedMessage } from 'react-intl';
import { useNavigate } from 'react-router-dom';

import back from './../../utils/images/arrow_back.svg';
import { Markup } from 'interweave';

import { LangContext } from "../../context/langContext";

import Spinner from './../../components/Spinner/Spinner';
import { getStaticPages } from "../../api/adminApi";

export default function StaticPage() {

    const navigate = useNavigate();

    const [englishText, setEnglishText] = useState('');
    const [spanishText, setSpanishText] = useState('');
    const [englishUpdate, setEnglishUpdate] = useState('');
    const [spanishUpdate, setSpanishUpdate] = useState('');

    const { locale } = useContext(LangContext);

    const [isLoading, setIsLoading] = useState(true);
    var URLactual = window.location.pathname.split('/');

    useEffect(() => {
        getStaticPages().then((response) => {

            const legalText = response.filter((legal) => legal.path === URLactual.slice(-1)[0]);

            legalText.map((legal) => {
                setIsLoading(false);
                if (legal.language === "SPANISH") {
                    setSpanishText(legal.body);
                    setSpanishUpdate(legal.sendeddate);
                } else {
                    setEnglishText(legal.body);
                    setEnglishUpdate(legal.sendeddate);
                }
            })
        })
    }, [URLactual]);

    return (
        <StaticPageContainer>

            <div className="goBack" onClick={() => navigate(-1)}>
                <img src={back} alt="go back" className="backIcon" />
                <p>
                    <FormattedMessage id="go_back" defaultMessage="ir atrás" />
                </p>
            </div>

            {/* <div className="termsHeader">
                 <h2 className="title"><FormattedMessage id="termsAndCondition_title" defaultMessage="Términos y condiciones" /></h2> 

                <div className="update"><FormattedMessage id="dataPolicy_text_date" defaultMessage="Última actualización:" />
                    <span> {(locale === 'es-CO') ? spanishUpdate : englishUpdate}</span>
                </div>
            </div> */}


            <div className="termsContainer">
                <div className="privacyBody">
                    {(locale === 'es-CO') ? (<Markup content={spanishText} />) : (<Markup content={englishText} />)}
                </div>
            </div>

            {(isLoading) && (<Spinner />)}

        </StaticPageContainer>
    )
}